import { Any } from "../types/Any";
import { KindKey, CustomType, TypeKey, UnionType, UnionCase } from "../symbols";

export const showType = T => {
  if (T == null) {
    return "Null";
  }

  if (T === Any) {
    return "Any";
  }

  if (T === String) {
    return "String";
  }

  if (T === Number) {
    return "Number";
  }

  if (T === Boolean) {
    return "Boolean";
  }

  if (T === RegExp) {
    return "RegExp";
  }

  if (Array.isArray(T)) {
    return `[ ${T.map(showType).join(", ")} ]`;
  }

  if (T[KindKey] === CustomType) {
    return T[TypeKey];
  }

  if (T[KindKey] === UnionType) {
    if (T[UnionCase]) {
      return `${T[TypeKey]}.${T[UnionCase]}`;
    } else {
      return T[TypeKey];
    }
  }

  if (T === Function) {
    return "Function";
  }

  if (T.constructor === Object) {
    return `{ ${Object.keys(T)
      .map(key => `${key}: ${showType(T[key])}`)
      .join(", ")} }`;
  }

  return T.toString()
    .replace(/function\s*/, "")
    .replace(/\(\)/, "")
    .replace(/\{\s\[native code\]\s\}/, "");
};
